import { Subscribe } from '@react-rxjs/core'
import React from 'react'

import { useLogAndCaptureLeftResult } from '../../../hooks/useLogAndCaptureLeftResult'
import { useDispensaryContext } from '../../../lib/dispensaries'
import { useDispensaryOrDefaultValues } from '../../../lib/dispensaries/hooks/useDispensaryOrDefaultValues'
import { latestDispensaryContact$ } from '../../../lib/sanity-dispensaries/contact'
import Spinner from '../../Spinner'
import { Approach } from './approach'
import { Hero } from './hero'
import { Information } from './information'
import { Introduction } from './introduction'
import { Meeting } from './meeting'

const DispensaryContent: React.FC = () => {
  const dispensary = useDispensaryContext()
  const sanityDispensaryResult = useDispensaryOrDefaultValues()
  useLogAndCaptureLeftResult(sanityDispensaryResult)

  const dispensaryResult =
    sanityDispensaryResult._tag === 'Right' ? sanityDispensaryResult.data : undefined

  const contact =
    sanityDispensaryResult._tag === 'Right' ? sanityDispensaryResult.data?.contact : undefined

  if (!dispensary || !dispensaryResult) {
    return null
  }

  return (
    <Subscribe source$={latestDispensaryContact$} fallback={<Spinner loading />}>
      <Hero
        displayName={contact?.displayName || dispensary?.name}
        specialties={contact?.specialties}
        logo={dispensaryResult.logo}
        image={contact?.image}
      />
      <Information contact={contact} />
      <Introduction blurb={contact?.blurb} />
      <Approach practice={contact?.practice} />
      <Meeting practice={contact?.practice} />
    </Subscribe>
  )
}

const DispensaryAbout: React.FC = () => {
  return (
    <Subscribe source$={latestDispensaryContact$} fallback={<Spinner loading />}>
      <DispensaryContent />
    </Subscribe>
  )
}

export default DispensaryAbout
